import { Component, inject, Inject, Input, Optional } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'candidate-details',
  imports: [CommonModule, MaterialModule],
  templateUrl: './candidate-details.component.html',
  styleUrl: './candidate-details.component.scss',
})
export class CandidateDetailsComponent {
  @Input() candidate: any;
  private _bottomSheetRef: any;
  @Input() showCloseButton = true;

  constructor(@Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public data?: any) {
    this.candidate = data;
    if (this.candidate?.resume_analysis?.candidate_id) {
      this._bottomSheetRef =
        inject<MatBottomSheetRef<CandidateDetailsComponent>>(MatBottomSheetRef);
    } else {
      this.showCloseButton = false;
    }
  }

  close() {
    this._bottomSheetRef.dismiss();
  }
}
